import axios from 'axios';

// N-100: admin-JWT (см. N-097) живёт 24 часа и истекает молча — без этого перехватчика
// каждая страница делала свой axios.get(...).then(...) без .catch(), поэтому истёкший
// токен просто топил промис: Dashboard вечно висел на "Загрузка...", остальные страницы
// показывали "нет данных". Разлогин/повторный вход помогал, потому что выдавал новый
// токен. Единая точка обработки — чтобы не патчить 16 страниц по отдельности.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('adminKey');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);
